<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
-->
<template>
  <div class="item" style="margin-left: 5px">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link" style="color: #fff">
        {{ user.realName }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <template v-if="openChildAccount">
          <el-dropdown-item icon="el-icon-setting" disabled v-if="subCountList.length > 0">
            主次账号切换
          </el-dropdown-item>
          <el-dropdown-item
            command="goBackParent"
            icon="el-icon-back"
            v-if="subCountList.length === 0"
          >
            回到主账号
          </el-dropdown-item>
          <el-dropdown-item
            v-for="item in subCountList"
            :key="item.userId"
            :command="item.userId"
            divided
          >
            <div class="df fdc" :class="{ current: item.userId === currentId }">
              <div class="df aic f14">
                <i class="el-icon-s-custom mr10"></i>
                <div class="showOne realName">
                  {{ item.realName }}
                </div>
                <div class="major" v-if="item.userId === user.userId">主</div>
                <div class="default" v-if="item.userId != user.userId">次</div>
              </div>
              <div class="df aic f12 showOne organName">
                {{ item.organName }}
              </div>
            </div>
          </el-dropdown-item>
        </template>
        <el-dropdown-item
          divided
          command="infoCenter"
          icon="el-icon-user"
          style="padding: 0px 15px"
        >
          个人中心
        </el-dropdown-item>
        <!-- <el-dropdown-item
                      command="homeSetting"
                      icon="el-icon-house"
                      style="padding:3px 15px"
                    >首页设置</el-dropdown-item> -->
        <el-dropdown-item
          divided
          command="layoutSetting"
          icon="el-icon-s-grid"
          style="padding: 0px 15px"
        >
          布局设置
        </el-dropdown-item>
        <el-dropdown-item
          divided
          command="loginOut"
          icon="el-icon-switch-button"
          style="padding: 0px 15px"
        >
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { openChildAccount } from '@/config';
export default {
  name: 'userMenu',
  inject: ['reload'],

  data() {
    return {
      subCountList: [],
      user: {},
      currentId: '',
      openChildAccount: openChildAccount
    };
  },

  computed: {
    setShow: {
      get: function () {
        return this.$store.state.settings.setShow;
      },
      set: function (nv) {
        this.$store.commit('setShow', nv);
      }
    }
  },

  created() {
    const user = sessionStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
      if (openChildAccount) {
        if (this.user.subAccounts) {
          this.subCountList = this.user.subAccounts;
          this.subCountList.unshift({
            realName: this.user.realName,
            organId: this.user.organId,
            organName: this.user.organName,
            userId: this.user.userId
          });
        }
        this.currentId = this.$store.state.init.currentUserId || this.user.userId;
      }
    }
  },

  methods: {
    async resetLoginInfo(user) {
      window.sessionStorage.setItem('token', user.token);
      window.sessionStorage.setItem('user', JSON.stringify(user));
      this.$store.commit('currentUserId', user.userId);
      this.$store.commit('visitedPathReset');
      this.$store.commit('isCollapse', false);
      this.$store.commit('setMenuList', []);
      this.$store.commit('resetSetting');
      // //删除当前主题色
      document.querySelector('#chalk-style') && document.querySelector('#chalk-style').remove();
      await this.getUserSetting();
      this.$router.push('/');
      this.$nextTick(() => {
        this.reload();
      });
    },
    //获取用户默认配置
    getUserSetting() {
      return new Promise((resolve, reject) => {
        if (!this.getGlobalConfig().getUserIndiviality) {
          resolve();
          return;
        }
        this.$api.formPost('/api/auth/sysuserprofile/doGetUserIndiviality', {}).then((res) => {
          if (res.retHead.code === '0000000') {
            this.$store.commit('setSetting', res.retBody);
          } else {
            this.$store.commit('setSetting', null);
          }
          resolve();
        });
      });
    },
    handleCommand(command) {
      if (command == 'loginOut') {
        this.loginOut();
      } else if (command == 'infoCenter') {
        this.$router.push('/user/mod-user');
      } else if (command == 'homeSetting') {
        this.$router.push('/sysfun/desk/layout');
      } else if (command == 'layoutSetting') {
        this.setShow = true;
      } else if (command == 'goBackParent') {
        this.$api.formPost('/syscommon/parentlogin', {}).then((res) => {
          this.currentId = res.retBody.userId;
          this.$message.success('切换成功');
          this.resetLoginInfo(res.retBody);
        });
      } else {
        if (this.user.userId === command) {
          this.$store.commit('currentUserId', command);
          return;
        }
        this.$api
          .formPost('/syscommon/sublogin', {
            subUserId: command
          })
          .then((res) => {
            this.$store.commit('currentUserId', command);
            this.resetLoginInfo(res.retBody);
            this.$message.success('切换成功');
          });
      }
    },
    loginOut() {
      sessionStorage.removeItem('token');
      this.$store.commit('visitedPathReset');
      this.$store.commit('isCollapse', false);
      this.$store.commit('currentUserId', '');
      sessionStorage.removeItem('user');
      this.$store.commit('setMenuList', []);
      this.$store.commit('resetSetting');
      this.showView = false;
      // //删除当前主题色
      document.querySelector('#chalk-style') && document.querySelector('#chalk-style').remove();
      if (window.sessionStorage.ticket && sso) {
        sso.logout();
      }
      this.$nextTick(() => {
        this.$router.push('/login');
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.major {
  color: #fff;
  background: var(--theme-color);
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  margin-left: 10px;
}
.default {
  color: #fff;
  background: #606266;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  margin-left: 10px;
}
.realName {
  color: #303133;
}
.organName {
  color: #909399;
}
.current {
  i {
    color: var(--theme-color);
  }
  .showOne {
    color: var(--theme-color) !important;
  }
}
</style>
